import { formatDate } from '@/utils/constants';
import { Box, Chip, Stack, Typography } from '@mui/material';
import React from 'react';
const GroupView = ({
	clientId,
	yearFolder,
	dealName,
	policies,
	clientName,
	policyCount,
	renewalDate,
}) => {
	return (
		<Box
			sx={{
				border: '1px solid',
				borderColor: 'divider',
				borderRadius: 1,
				p: 1.5,
			}}
		>
			<Stack direction='column' spacing={2}>
				<Stack
					direction={{ xs: 'column', sm: 'row' }}
					justifyContent='space-between'
					spacing={1}
				>
					<Stack>
						<Typography fontWeight={700}>{clientName}</Typography>
						<Stack direction='row' spacing={2}>
							<Typography variant='body2' color='text.secondary'>
								{dealName}
							</Typography>
							<Typography variant='body2' color='text.secondary'>
								{`(${yearFolder})`}
							</Typography>
						</Stack>
					</Stack>
					<Stack direction='row' spacing={2} flexWrap='wrap' useFlexGap>
						<Chip
							size='small'
							label={`${policyCount} polic${policyCount === 1 ? 'y' : 'ies'}`}
						/>
						<Typography sx={{ mt: '1.5px' }}>{formatDate(renewalDate)}</Typography>
					</Stack>
				</Stack>
				<Stack direction='row' spacing={1} flexWrap='wrap' useFlexGap>
					{policies.map((policy) => (
						<Chip
							key={`${clientId}-${policy.id}`}
							size='small'
							label={`${policy.classOfRisk || 'Policy'}${policy.policyNumber ? `- ${policy.policyNumber}` : ''}`}
						/>
					))}
				</Stack>
			</Stack>
		</Box>
	);
};
GroupView.displayName = 'GroupView';
export default GroupView;
